<template>
    <div class="select">
        <div
            class="select-title"
            :class="{ default: !hasActiveInputs, focus: isOpen }"
            @click="toggleSelect"
            ref="selectTitle"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.81239 4.4375C5.81239 4.25516 5.73996 4.0803 5.61103 3.95136C5.4821 3.82243 5.30723 3.75 5.12489 3.75C4.94256 3.75 4.76769 3.82243 4.63876 3.95136C4.50982 4.0803 4.43739 4.25516 4.43739 4.4375V16.5279L2.86164 14.9507C2.73255 14.8217 2.55746 14.7491 2.37489 14.7491C2.19233 14.7491 2.01724 14.8217 1.88814 14.9507C1.75905 15.0798 1.68652 15.2549 1.68652 15.4375C1.68652 15.6201 1.75905 15.7952 1.88814 15.9242L4.63814 18.6729L4.64777 18.6825C4.77685 18.8084 4.95043 18.8781 5.13072 18.8766C5.311 18.875 5.48336 18.8023 5.61027 18.6742L8.36027 15.9242C8.42419 15.8604 8.47491 15.7846 8.50954 15.7012C8.54417 15.6178 8.56202 15.5283 8.56209 15.438C8.56215 15.3477 8.54442 15.2582 8.50991 15.1747C8.4754 15.0912 8.42479 15.0154 8.36095 14.9514C8.29712 14.8875 8.22133 14.8368 8.13789 14.8022C8.05446 14.7675 7.96502 14.7497 7.87469 14.7496C7.78436 14.7496 7.6949 14.7673 7.61141 14.8018C7.52793 14.8363 7.45206 14.8869 7.38814 14.9507L5.81239 16.5279V4.4375ZM10.6249 5.8125C10.6249 5.63016 10.6973 5.4553 10.8263 5.32636C10.9552 5.19743 11.1301 5.125 11.3124 5.125H20.9374C21.1197 5.125 21.2946 5.19743 21.4235 5.32636C21.5525 5.4553 21.6249 5.63016 21.6249 5.8125C21.6249 5.99484 21.5525 6.1697 21.4235 6.29864C21.2946 6.42757 21.1197 6.5 20.9374 6.5H11.3124C11.1301 6.5 10.9552 6.42757 10.8263 6.29864C10.6973 6.1697 10.6249 5.99484 10.6249 5.8125ZM11.3124 9.25C11.1301 9.25 10.9552 9.32243 10.8263 9.45136C10.6973 9.5803 10.6249 9.75516 10.6249 9.9375C10.6249 10.1198 10.6973 10.2947 10.8263 10.4236C10.9552 10.5526 11.1301 10.625 11.3124 10.625H18.1874C18.3697 10.625 18.5446 10.5526 18.6735 10.4236C18.8025 10.2947 18.8749 10.1198 18.8749 9.9375C18.8749 9.75516 18.8025 9.5803 18.6735 9.45136C18.5446 9.32243 18.3697 9.25 18.1874 9.25H11.3124ZM11.3124 13.375C11.1301 13.375 10.9552 13.4474 10.8263 13.5764C10.6973 13.7053 10.6249 13.8802 10.6249 14.0625C10.6249 14.2448 10.6973 14.4197 10.8263 14.5486C10.9552 14.6776 11.1301 14.75 11.3124 14.75H15.4374C15.6197 14.75 15.7946 14.6776 15.9235 14.5486C16.0525 14.4197 16.1249 14.2448 16.1249 14.0625C16.1249 13.8802 16.0525 13.7053 15.9235 13.5764C15.7946 13.4474 15.6197 13.375 15.4374 13.375H11.3124ZM11.3124 17.5C11.1301 17.5 10.9552 17.5724 10.8263 17.7014C10.6973 17.8303 10.6249 18.0052 10.6249 18.1875C10.6249 18.3698 10.6973 18.5447 10.8263 18.6736C10.9552 18.8026 11.1301 18.875 11.3124 18.875H12.6874C12.8697 18.875 13.0446 18.8026 13.1735 18.6736C13.3025 18.5447 13.3749 18.3698 13.3749 18.1875C13.3749 18.0052 13.3025 17.8303 13.1735 17.7014C13.0446 17.5724 12.8697 17.5 12.6874 17.5H11.3124Z" fill="#9D9D9D"/>
            </svg>
            {{ title }}
            <div class="arrow" :class="{ active: isOpen }"></div>
        </div>
        <div class="select-content" :style="{ maxHeight: isOpen ? `${contentHeight}px` : '0' }" ref="selectContent">
            <div v-for="input in inputs" :key="input.name" class="select-item">
                <label>
                    <input type="checkbox" :name="input.name" v-model="input.selected" @change="emitActiveValues" />
                    {{ input.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CheckboxSelect',
    props: {
        title: {
            type: String,
            required: true,
        },
        inputs: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
            contentHeight: 0,
        };
    },
    computed: {
        hasActiveInputs() {
            return this.inputs.some(input => input.checked);
        },
    },
    methods: {
        toggleSelect() {
            this.isOpen = !this.isOpen;
            this.contentHeight = this.isOpen ? this.$refs.selectContent.scrollHeight : 0;
        },
        emitActiveValues() {
            const activeValues = this.inputs
                .filter(input => input.selected)
                .map(input => input.name);
            this.$emit('changed', activeValues);
        },
        handleClickOutside(event) {
            if (this.isOpen && 
                !this.$refs.selectContent.contains(event.target) &&
                !this.$refs.selectTitle.contains(event.target)) {
                this.isOpen = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
};
</script>


<style scoped lang="scss">
.select {
    width: 100%;
    position: relative;
}

.select-title {
    padding: 0 15px;
    color: #505050;
    border: 1px solid #e5e5e5;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 56px;
    transition: 0.5s all;
    border-radius: 8px;
    &:hover{
      border: 1px solid #9D9D9D;
    }
    img{
        width: 24px;
        min-width: 24px;
        height: 24px;
        transition: 0.5s all;
    }
    .arrow{
        margin-left: auto;
        transform: rotate(0deg);
        transition: 0.5s all;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 24px;
        width: 24px;
        min-width: 24px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        opacity: 0.6;
        position: relative;
        &::before {
            width: 24px !important;
            height: 24px !important;
            background: url("/webpack-assets/img/icons/angle-down.svg") center center no-repeat;
            border: none !important;
            transition: 0.2s;
            content: "";
        }
        &::after {
            position: absolute;
            left: 0;
            opacity: 0;
            content: "";
            display: block;
            width: 24px !important;
            height: 24px !important;
            background: url("/webpack-assets/img/icons/angle-down_blue.svg") center center
            no-repeat;
            border: none !important;
            transition: 0.2s;
        }
        &.active{
            &::before {
                transform: scale(1, -1);
            }
            &::after {
                transform: scale(1, -1);
                opacity: 1;
            }
        }
    }

    &.default{
        color: #9ba1ab;
        >img{
            opacity: 0.6;
        }
    }
    svg{
        path{
            transition: 0.4s all;
        }
    }
    &.focus{
        border: 1px solid #4e8aff !important;
        color: #4e8aff;
        svg{
            path{
                fill: #4e8aff;
            }
        }
    }
}

.select,.select-content{
    border: 0;
    border-radius: 8px;
    background-color: #fff;
    font-family: "Avenir-Next", sans-serif;
    font-weight: 100;
    font-size: 16px;
    line-height: 24px;
}

.select-content {
    overflow: hidden;
    border: 0;
    position: absolute;
    left: 0;
    top: 60px;
    width: 100%;
    z-index: 6;
    transition: 0.5s all;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .15), 0 4px 4px 0 rgba(0, 0, 0, .25);
}

.select-item {
    label{
        padding: 12px 20px;
        display: flex;
        align-items: center;
        gap: 15px;
        color: #505050;
        font-family: "Avenir-Next", sans-serif;
        font-weight: 100;
        font-size: 16px;
        line-height: 24px;
        cursor: pointer;
        input{
            margin: 0;
            width: 20px;
            min-width: 20px;
            height: 20px;
            border-radius: 4px;
            background: #fff;
            border: 1.45px solid #9D9D9D !important;
            position: relative;
            transition: 0.4s all;
            background-position: center;
            background-repeat: no-repeat;
            //background-image: url('/webpack-assets/img/ui-kit/checkmark.svg');
            background-size: 20px !important;
            &::after{
                position: absolute;
                content: '';
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                transition: 0.4s;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 20px !important;
                background-image: url('/webpack-assets/img/ui-kit/checkmark-hover.svg');
            }
            @media only screen and (min-width: 767px) {
                &:hover{
                    //background-image: url('/webpack-assets/img/ui-kit/checkmark.svg') !important;
                }
            }
            &:checked{
                border: 1.45px solid #4E8AFF !important;
                &::after{
                    opacity: 1;
                    background-color: #4E8AFF;
                    background-position: center;
                    background-repeat: no-repeat;
                    
                    background-image: url('/webpack-assets/img/ui-kit/checkmark.svg') !important;
                }
   
                //background-size: 12px;
                @media only screen and (min-width: 767px) {
                    &:hover{
                        background-position: center;
                        background-repeat: no-repeat;
                        //background-image: url('/webpack-assets/img/ui-kit/checked-05.svg') !important;
                    }
                }
            }
        }

        &:hover{
            background: #4E8AFF1A;
            input{
                border: 1.45px solid #4E8AFF99 !important;
                &::after{
                    opacity: 1;
                }
            }
        }
        &:has(input:checked) {
            color: #4E8AFF;
            background: #4E8AFF33;
            border-color: #4a90e2 !important;
        }
    }
}
</style>